// ─────────────────────────────────────────────────────────────────────────────
// 🔑 DOORLY SUPPORT'S PHONE NUMBER — ONE SOURCE (round 2, Jesse/Hannah 2026-11-04; round 3 approvals 11/4: one constant,
// a display form and a tel form, so the number changes in ONE place when JustCall arrives). Every borrower-facing support
// number in the app reads these: the dashboard's "Call us at …" text and the phone's "Call support" tel: link, the wire
// instructions, the e-sign "Prefer paper?" line, the offer review and the wire-readiness notice.
// backend/constants/support.js is the server's copy; backend/test/supportPhone.test.js fails if the two disagree.
// (Signed or hashed legal wording — the ESIGN recital, PDFs, regulated notices — keeps its own text: see that test.)
// ─────────────────────────────────────────────────────────────────────────────
export const SUPPORT_PHONE_E164 = '+15127136016';
export const SUPPORT_PHONE_DISPLAY = '(512) 713-6016';
export const SUPPORT_PHONE_TEL = `tel:${SUPPORT_PHONE_E164}`;
